import React from "react";
import ImageModule from "../../../modules/image_module";
import BPTW_Logo from "../../../images/bptw_logo.png";
import GPTW_Logo from "../../../images/gptw_logo.png";

const ComplianceLogo = () => {
    return (<>
        <div className="compliance_logo">
            <ImageModule ImageSrc={{url:BPTW_Logo}} altText={"BPTW Logo"} width="210" height="104" loading="lazy" />
            <ImageModule ImageSrc={{url:GPTW_Logo}} altText={"GPTW Logo"} width="66" height="113" loading="lazy" />
        </div>
    </>)
}
export default ComplianceLogo;